import { Panel, PanelBody } from "components/Panel";
import { useRefData } from "common/hooks";
import * as utils from "common/utils";
import { WriteMode } from "components/AnalysisRenderMode";
import ActionLink from "components/ActionLink";
import Button from "components/Button/Button";
import { useForestModal } from "./ForestModal";

export default function Forests({ form, forests = [] }) {
    const refData = useRefData();

    const deleteForest = (forestId) => () => {
        const updatedForests = forests.reduce((acc, cur) => {
            if (cur.id !== forestId) {
                acc.push(cur);
            }
            return acc;
        }, []);
        form.change("forests", updatedForests);
    };

    const onSave = (forest) => {
        if (forest.isNew) {
            form.change("forests", [...forests, { ...forest, isNew: false }]);
        } else {
            form.change(
                "forests",
                forests.map((f) => {
                    if (f.id === forest.id) {
                        return forest;
                    }
                    return f;
                })
            );
        }
    };
    const [openForestModal, forestModal] = useForestModal(forests, onSave);

    return (
        <>
            <Panel
                title={`Forests (${forests.length})`}
                className="u-mt-lg"
                info="Adding forest details will enable indicative estimation of carbon stocks based on look-up tables for post 1989 forest land by MPI. You will find this report under the GHG reporting section."
                actions={
                    <WriteMode>
                        <ActionLink id="add-forest-link" className="IconLink--arrow-plus u-textWhite" onClick={() => openForestModal()}>
                            Add forest
                        </ActionLink>
                    </WriteMode>
                }
                skyBlue
            >
                <PanelBody className="u-p-0">
                    <div className="Table u-mt-md">
                        <table>
                            <thead>
                                <tr>
                                    <th data-width="40">Name/Type</th>
                                    <th data-width="20" className="u-textRight">
                                        Age
                                    </th>
                                    <th data-width="20" className="u-textRight">
                                        Harvested
                                    </th>
                                    <th data-width="20" className="u-textRight">
                                        %
                                    </th>
                                    <WriteMode>
                                        <th className="th--shrink"></th>
                                    </WriteMode>
                                </tr>
                            </thead>
                            <tbody>
                                {forests.length === 0 && (
                                    <tr>
                                        <td colSpan="5">
                                            <div className="Tile-body-message">
                                                <p className="h4 u-mt-0">This block does not have any forest details</p>
                                                <WriteMode>
                                                    <Button id="add-forest-button" onClick={() => openForestModal()} className="IconLink--arrow-plus Button Button--secondary u-mt-md">
                                                        Add forest
                                                    </Button>
                                                </WriteMode>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                {forests.length > 0 &&
                                    forests.map((forest) => {
                                        return (
                                            <tr key={forest.id}>
                                                <td onClick={() => openForestModal(forest)}>
                                                    <div className="u-flexSplit u-link a">
                                                        <span>{forest.name || utils.valueToText(refData.forestType, forest.forestType)}</span>
                                                        <span className="icon icon-edit" />
                                                    </div>
                                                </td>
                                                <td className="u-textRight">{forest.forestAge}</td>
                                                <td className="u-textRight">{forest.isHarvested ? "Yes" : "No"}</td>
                                                <td className="u-textRight">{forest.percentage}</td>
                                                <WriteMode>
                                                    <td>
                                                        <ActionLink id={`remove-forest-${forest.id}`} className="IconLink--trash" onClick={deleteForest(forest.id)} title="Delete" />
                                                    </td>
                                                </WriteMode>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                </PanelBody>
            </Panel>
            {forestModal}
        </>
    );
}
